import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const RecentUploads = () => {
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUploads = async () => {
      try {
        const response = await axios.get(
          "https://kkblossomschool.org/KKBlossomsWebsite/api.php?action=getRecentUploads"
        );

        const dataArray = Array.isArray(response.data) ? response.data : [];
        setUploads(dataArray);
      } catch (error) {
        console.error("Error fetching uploads:", error);
        setUploads([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUploads();
  }, []);

  if (loading) return <p>Loading uploads...</p>;
  if (uploads.length === 0) return <p>No uploads found.</p>;

  // Group images by caption
  const groupedByCaption = uploads.reduce((acc, item) => {
    const key = item.caption || "No Caption";
    if (!acc[key]) acc[key] = [];
    acc[key].push(item.image);
    return acc;
  }, {});

  // Slider settings
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000, // ✅ 3 seconds
  };

  return (
    <div className="container-fluid py-5">
      <div className="container py-5">
        <div className="section-title text-center position-relative mb-5">
          <h6 className="d-inline-block position-relative text-secondary text-uppercase pb-2">
            Recent Uploads
          </h6>
          <h1 className="display-4">Latest Activities</h1>
        </div>

        <div className="row">
          {Object.keys(groupedByCaption).map((caption, idx) => (
            <div className="col-lg-6 col-md-6 mb-4" key={idx}>
              <div
                className="team-item bg-light h-100"
                style={{
                  borderRadius: "20px",
                  overflow: "hidden",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.15)"
                }}
              >
                <Slider {...sliderSettings}>
                  {groupedByCaption[caption].map((imgName, index) => (
                    <div key={index}>
                      <img
                        className="img-fluid w-100"
                        src={`https://kkblossomschool.org/KKBlossomsWebsite/uploads/${imgName}`}
                        alt={`upload-${index}`}
                        style={{ height: "430px", objectFit: "fit" }}
                      />
                    </div>
                  ))}
                </Slider>

                <div className="text-center p-4">
                  <p className="mb-2 font-weight-bold">{caption}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecentUploads;